module.exports = __webpack_public_path__ + "img/松果体机器人.8bdc2830.png";